// extracted by mini-css-extract-plugin
export default {"card":"GridList_card__LyENR","grid-container":"GridList_grid-container__BRZds","grid-ul":"GridList_grid-ul__etwCD","grid-li":"GridList_grid-li__2THgq"};